import { ReactNode } from "react";
import Header from "../header/Header";
import { FloatingChatButton } from "../components/FloatingChatButton";
import { theme } from "../theme";

type MainLayoutProps = {
  children: ReactNode;
};

export const MainLayout = ({ children }: MainLayoutProps) => {
  return (
    <div className={theme.layout.page}>
      {/* Atmospheric background layers */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
        {/* Subtle radial teal accent — top center */}
        <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[900px] h-[500px] rounded-full dark:opacity-100 opacity-0 blur-[100px] bg-sy-teal/[0.035]" />
        {/* Dot grid pattern */}
        <div
          className="absolute inset-0 dark:opacity-[0.035] opacity-[0.025]"
          style={{
            backgroundImage: "radial-gradient(circle at 1px 1px, currentColor 1px, transparent 0)",
            backgroundSize: "32px 32px",
          }}
        />
      </div>
      <Header />
      <main className="flex-grow w-full relative">
        <div className="w-full h-full">{children}</div>
      </main>
      <FloatingChatButton />
    </div>
  );
};

export default MainLayout;
